export default {"src":"//jsak.mmtcdn.com/tripmoney/apps/v2/landing-pages/_next/static/media/orderUnavaiable.c2eab3a5.svg","height":24,"width":24};